import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 – Siden blev ikke fundet"
        description="Den side, du leder efter, findes desværre ikke hos Havdrup Rengøring."
      />

      <section className="py-20 sm:py-28 bg-gradient-to-b from-[#0d3836]/10 to-white text-center">
        <div className="mx-auto max-w-2xl px-4 sm:px-6">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0d3836]/10 text-[#0d3836]">
            <i className="fa-regular fa-sparkles text-2xl" aria-hidden="true" />
          </div>

          <span className="text-sm font-semibold uppercase tracking-wider text-[#0d3836]">
            Fejl 404
          </span>
          <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 font-display">
            Vi kunne ikke finde siden
          </h1>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Siden du leder efter findes desværre ikke eller kan være flyttet. Måske har du tastet forkert eller fulgt et forældet link.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0d3836] px-6 py-3 text-sm font-semibold text-white shadow-xs hover:bg-[#154e4a] transition-colors cursor-pointer w-full sm:w-auto justify-center"
            >
              <i className="fa-regular fa-house text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50 transition-colors cursor-pointer w-full sm:w-auto justify-center"
            >
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-xs text-slate-500 mb-3">Vores mest populære ydelser:</p>
            <div className="flex flex-wrap items-center justify-center gap-2 text-xs">
              <Link to="/privat-rengoering" className="rounded-lg bg-white border border-slate-200 px-3 py-1.5 text-slate-700 hover:text-[#0d3836] hover:border-[#0d3836]/30 transition-colors">
                Privat rengøring
              </Link>
              <Link to="/erhvervsrengoering" className="rounded-lg bg-white border border-slate-200 px-3 py-1.5 text-slate-700 hover:text-[#0d3836] hover:border-[#0d3836]/30 transition-colors">
                Erhvervsrengøring
              </Link>
              <Link to="/klinik-rengoering" className="rounded-lg bg-white border border-slate-200 px-3 py-1.5 text-slate-700 hover:text-[#0d3836] hover:border-[#0d3836]/30 transition-colors">
                Klinik rengøring
              </Link>
              <Link to="/hovedrengoering" className="rounded-lg bg-white border border-slate-200 px-3 py-1.5 text-slate-700 hover:text-[#0d3836] hover:border-[#0d3836]/30 transition-colors">
                Hovedrengøring
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
